<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <div class="content">
        <a-form ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
          <SmallSquare class="m-b-20" content="礼品基本信息" />
          <a-form-item ref="gift_name" label="礼品名称" name="gift_name" help='（限50个汉字/100个字符以内）' :rules="[{ required: true, message: '请输入礼品名称' }]">
            <a-input v-model:value="form.gift_name" placeholder="请输入礼品名称" max-lengt="100" />
          </a-form-item>
          <a-form-item ref="gift_category_id" label="礼品分组" name="gift_category_id">
            <a-row>
              <a-col :span="18">
                <a-select v-model:value="form.gift_category_id" ref="select" placeholder="礼品分类" allowClear>
                  <a-select-option :value="v.id" v-for="(v,k) in cateList" :key="k">
                    {{v.name}}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="2">
                <a-button type="link" @click="$router.push('/product/gift/gift/Cate/index')">
                  添加分组
                </a-button>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="image_url" label="礼品图片" name="image_url" :rules="[{ required: true, message: '请添加礼品图片' }]" help="图片宽高要求1:1比例，建议尺寸为640px*640px以上；最多上传5张图片。">
            <material :groupType="1" :imageList="form.image_url" :max="5" v-on:handlechoose="(data) => {form.image_url.push(...data);}
              " v-on:handledel="(data) => {form.image_url = data;}" />
          </a-form-item>
          <a-form-item ref="market_price" label="市场价值" name="market_price" :rules="[{ required: true, message: '请输入市场价' }]">
            <a-input v-model:value="form.market_price" prefix="￥" suffix="RMB" type="number" placeholder="请输入市场价值" v-inputFilter:price />
          </a-form-item>
          <SmallSquare class="m-b-20" content="礼品描述信息" />
          <!--礼品规格-->
          <a-form-item ref="spec_many" label="礼品规格" name="spec_many" :wrapper-col="{ span: 20}">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="spec_type" checked-children="多" un-checked-children="单" :disabled="$route.query.id" />
            <template v-if="spec_type">
              <a-form-item v-for="(v, k) in skus" :key="k" v-bind="index === 0 ? formItemLayout : {}">
                <div class="parameterItem" v-if="skus.length">
                  <a-input v-model:value="v.spec_name" placeholder="规格名" style="width: 80px; margin-right: 8px" />
                  <template v-for="(value,key) in v.spec_value" :key="key">
                    <a-input placeholder="规格值" style="width: 80px;;margin-right: 8px" :value="value.name" v-model:value="value.name" />
                    <MinusCircleOutlined class="dynamic-delete-button m-r-10" @click="removeskuvalue(k,key)" v-if="!$route.query.id" />
                  </template>
                  <a-input v-model:value="v.value" placeholder="规格值" @onSearch="addSku" style="width: 20%" v-if="skus.length" />
                  <a-button @click="addSku(k)" class='m-l-10' v-if="!$route.query.id"> 添加 </a-button>
                  <MinusCircleOutlined class="dynamic-delete-button m-l-10" @click="removesku(k)" v-if="!$route.query.id" />
                </div>
              </a-form-item>
              <a-form-item v-if="!$route.query.id">
                <a-button type="dashed" @click="addParameter" class='m-r-20'>
                  <PlusOutlined /> 追加规格
                </a-button>
                <a-button type="dashed" @click="cretateSpace(false)">
                  <PlusOutlined /> 生成规格
                </a-button>
              </a-form-item>
              <a-table bordered :data-source="specGridCell" :columns="columns" :pagination='false'>
                <template #name="{ record }">
                  <p class="width-50"><span v-for="(v,k) in record.propertyList" :key='k'>{{v.value}}{{record.propertyList[k+1]?'__':''}}</span></p>
                </template>
                <template #imageUrl="{ record }">
                  <material :image="record.image_url" :groupType='1' :max="1" v-on:handlechoose="(data)=>{record.image_url=data}" v-on:handledel="(data)=>record.image_url=''" />
                </template>
                <template #stockNum="{ record }">
                  <a-input-number placeholder="库存" :value="record.stock_num" v-model:value="record.stock_num" v-inputFilter:Int />
                </template>
                <template #marketPrice="{ record }">
                  <a-input-number placeholder="礼品价格" :value="record.market_price" v-model:value="record.market_price" v-inputFilter:price />
                </template>
                <template #number="{ record }">
                  <a-input :value="record.number" placeholder="礼品编号" v-inputFilter:sn v-model:value="record.number" :disabled="$route.query.id" />
                </template>
              </a-table>
              <div v-if="specGridCell&&specGridCell.length&&!$route.query.id" class='m-t-10'>
                <a-popconfirm @confirm="confirmSetPrice" @cancel="SetPrice=0" class='m-r-10'>
                  <template #title>
                    <a-input-number placeholder="礼品价格" :value="SetPrice" v-model:value="SetPrice" v-inputFilter:price />
                  </template>
                  <template #icon>
                    <span></span>
                  </template>
                  <a-button>
                    <PlusOutlined /> 批量设置价格
                  </a-button>
                </a-popconfirm>
                <a-popconfirm @confirm="confirmSetStock" @cancel="SetStockNum=0">
                  <template #title>
                    <a-input-number placeholder="产品库存" :value="SetStockNum" v-model:value="SetStockNum"  v-inputFilter:Int />
                  </template>
                  <template #icon>
                    <span></span>
                  </template>
                  <a-button>
                    <PlusOutlined /> 批量设置库存
                  </a-button>
                </a-popconfirm>
              </div>
            </template>
          </a-form-item>
          <!--礼品规格结束-->
          <a-form-item ref="number" label="礼品编号" name="number" help='（仅支持数字、字母及英文"-"）' :rules="[{ required: true, message: '请输入礼品编号' }]">
            <a-input v-model:value="form.number" placeholder="请输入礼品编号" v-inputFilter:sn  :disabled="$route.query.id"/>
          </a-form-item>
          <a-form-item ref="gift_weight" label="礼品重量" name="gift_weight">
            <a-input v-model:value="form.gift_weight" type="number" :min='0' placeholder="礼品重量" suffix="kg" />
          </a-form-item>
          <a-form-item ref="stock_num" label="库存" name="stock_num" v-if="!spec_type" :rules="[{ required: true, message: '请输入库存' }]">
            <a-input v-model:value="form.stock_num" suffix="件" type="number" placeholder="请输入库存" />
          </a-form-item>
          <!-- <a-form-item ref="market_price" label="礼品价格" name="market_price" :rules="[{ required: true, message: '请输入礼品价格' }]" v-if="!spec_type">
            <a-input v-model:value="form.market_price" prefix="￥" suffix="RMB" type="number" placeholder="请输入礼品价格" v-inputFilter:price  />
          </a-form-item> -->
          <a-form-item ref="sort" label="列表排序" name="sort">
            <a-input v-model:value="form.sort" placeholder="列表排序" />
          </a-form-item>
          <SmallSquare class="m-b-20" content="礼品详情" />
          <app-warp title="礼品详情" class='m-l-50'>
            <template #app-content>
              <div class="app-content" v-html="form.content">
              </div>
            </template>
            <template #app-sider  >
              <div style="margin-left:70px"> 
              <quill v-model:value="form.content" :height="700"  :content="JSON.parse(JSON.stringify(form.content))"/>
              </div>
            </template>
          </app-warp>
          <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
            <a-button @click="$router.go(-1)" class='m-r-10'> 返回 </a-button>
            <a-button type="primary" @click="onSubmit()"> 提交 </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import {
  MinusCircleOutlined,
  // EditOutlined,
} from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import {
  getGiftCate,
  createGift,
  getGiftDetail,
  editGift,
} from "@/api/product.js";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  gift_name: "",
  gift_category_id: "",
  market_price: "",
  stock_num: "",
  number: "",
  gift_weight: "",
  sort: "",
  content: "",
  parameter: [],
  image_url: [],
  product_category_type_id: null,
  spec_many: {},
};

export default {
  components: {
    MinusCircleOutlined,
    /*EditOutlined*/
  },
  setup() {
    //pass
    const form = ref(JSON.parse(JSON.stringify({ ...defForm })));
    const state = reactive({
      SetStockNum: 0,
      SetPrice: 0,
      current: 0,
      content: "",
      spec_type: false,
      skusValidateForm: {
        skus: [],
      },
      cateList: [], //分类列表
      dataSource: [],
      targetKeys: [],
      fileList: [],
      loading: false,
      imageUrl: "",
      previewVisible: false,
      previewImage: "",
      labelCol: { span: 3 },
      wrapperCol: { span: 9 },

      columns: [],
      basecolumns: [
        {
          title: "规格图片",
          dataIndex: "imageUrl",
          slots: { customRender: "imageUrl" },
        },
        {
          title: "价格(元)",
          dataIndex: "marketPrice",
          slots: { customRender: "marketPrice" },
        },
        {
          title: "库存",
          dataIndex: "stockNum",
          slots: { customRender: "stockNum" },
        },

        {
          title: "礼品编号",
          dataIndex: "number",
          slots: { customRender: "number" },
        },
      ],
    });
    const ruleForm = ref();
    const momentTime = inject("momentTime");
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");

    // 初始化
    const init = async () => {
      // 获取分类列表
      let result = await getGiftCate().then((res) => res.data);
      state.cateList = result.data;

      // 获取页面参数
      if ($route.query.id) {
        // 获取详情
        getGiftDetail($route.query.id).then((res) => {
          var result = res.data.data;
          state.spec_type = result.spec_type == 2 ? true : false;
          form.value = result;

          form.value.content = result.content.content;
          var image_url = [];
          result.image.forEach((v, k) => {
            image_url[k] = v.image_url;
          });
          form.value.image_url = image_url;
          if (result.specValue) {
            specGridCell.value = result.sku;
            skus.value = JSON.parse(result.specValue.skus);
            cretateSpace(true);
          }
        });
      }
    };
    init();
    const skus = ref([]); //存放添加规格的表单
    const spec_many = ref(); //规格提交的数据、
    const addParameter = () => {
      if (skus.value.length >= 3) {
        message.error("规格最多输入3种");
        return;
      }
      skus.value.push({
        spec_value: [],
        spec_name: "",
        value: "",
      });
    };
    // 删除规格
    const removesku = (index) => {
      skus.value.splice(index, 1);
    };
    // 追加规格值
    const addSku = async (k) => {
      if (skus.value[k].spec_value.length == 5) {
        message.error("属性最多输入5种");
        return;
      }
      if (!skus.value[k].value || !skus.value[k].spec_name) {
        message.error("请输入完整");
        return;
      }
      skus.value[k].spec_value.push({ name: skus.value[k].value });
      skus.value[k].value = "";
    };
    // 清除规格中的某个值
    const removeskuvalue = (key, index) => {
      skus.value[key].spec_value.splice(index, 1);
    };
    // 生成属性
    const specGridCell = ref();
    const cretateSpace = (is_detail) => {
      var spec_many = {
        spec_attr: "",
        spec_list: [],
      };
    console.log(skus)
      // 过滤空白的规格
      let normlizeList = skus.value.map((item) => {
        return {
          spec_name: item.spec_name,
          spec_value: item.spec_value.filter((value) => value.name),
        };
      });
      // 获取规格数据
      if (is_detail) {
        specGridCell.value = spaceHandle(normlizeList).map((item, key) => {
          return {
            propertyList: item,
            market_price: specGridCell.value[key].market_price,
            stock_num: specGridCell.value[key].stock_num,
            product_sales: specGridCell.value[key].product_sales,
            gift_weight: specGridCell.value[key].gift_weight,
            image_url: specGridCell.value[key].image_url,
            number: specGridCell.value[key].number,
          };
        });
      } else {
        specGridCell.value = spaceHandle(normlizeList).map((item, key) => {
          return {
            propertyList: item,
            market_price: 0,
            stock_num: 0,
            product_sales: 0,
            gift_weight: 0,
            image_url: "",
            number: "",
          };
        });
      }
      // 整理数据
      specGridCell.value.forEach((v, key) => {
        if (v.propertyList.length) {
          v.propertyList.forEach((element, index) => {
            v["text" + index] = element.value;
          });
        }
      });
      // 动态生成表头
      var columns = [];
      normlizeList.forEach((element, key) => {
        columns.push({
          title: element.spec_name,
          dataIndex: "text" + key,
          key: "text" + key,
          customRender: ({ text }) => {
            const obj = {
              children: text,
            };
            return obj;
          },
        });
      });
      state.columns = columns.concat(state.basecolumns);
    };
    // 处理多规格数据
    const spaceHandle = (arr) => {
      function mix(item1, item2) {
        var arr1 = Array.isArray(item1.spec_value) ? item1.spec_value : item1;
        var arr2 = item2.spec_value;
        var result = [];
        for (let i = 0; i < arr1.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            let item = [];
            if (Array.isArray(arr1[i])) {
              item = item.concat(arr1[i]);
              item.push({
                name: item2.spec_name,
                value: arr2[j].name,
              });
            } else {
              item.push({
                name: item1.spec_name,
                value: arr1[i].name,
              });
              item.push({
                name: item2.spec_name,
                value: arr2[j].name,
              });
            }
            result.push(item);
          }
        }
        return result;
      }
      if (arr.length < 1) {
        return [];
      } else if (arr.length < 2) {
        let result = [];
        let item = arr[0];
        item.spec_value.map((value) => {
          result.push([
            {
              name: item.spec_name,
              value: value.name,
            },
          ]);
        });
        return result;
      } else {
        return arr.reduce((acc, item) => {
          return mix(acc, item);
        });
      }
    };
    // 批量设置价格
    const confirmSetPrice = () => {
      specGridCell.value.forEach((v) => {
        v["market_price"] = state.SetPrice;
      });
    };
    // 批量设置库存
    const confirmSetStock = () => {
      specGridCell.value.forEach((v) => {
        v["stock_num"] = state.SetStockNum;
      });
    };
    // 批量设置
    const allset = (data) => {
      specGridCell.value.forEach((v) => {
        v["market_price"] = data["market_price"];
        v["market_price"] = data["market_price"];
        v["stock_num"] = data["stock_num"];
        v["gift_weight"] = data["gift_weight"];
        v["image_url"] = data["image_url"];
        v["number"] = data["number"];
      });
    };

    const router = inject("$router");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          if (state.spec_type) {
            // 多规格

            var flag = false;
            specGridCell.value.forEach((element) => {
              for (const key in element) {
                if (key == "image_url" && !element[key]) {
                  flag = "请完善礼品图片";
                }
                if (key == "number" && !element[key]) {
                  flag = "请完善礼品编号";
                }
                if (key == "market_price" && !element[key]) {
                  flag = "请完善礼品价格";
                }
                if (key == "stock_num" && !element[key]) {
                  flag = "请完善礼品库存";
                }
              }
            });
            if (flag) {
              message.error(flag);
              return;
            }
          }
          var result;
          let json = {
            ...e,
            content: form.value.content,
            spec_many: JSON.stringify(specGridCell.value),
            skus: JSON.stringify(skus.value),
            spec_type: state.spec_type ? 2 : 1,
          };
          if ($route.query.id) {
            result = await editGift($route.query.id, json).then(
              (res) => res.data
            );
          } else {
            result = await createGift(json).then((res) => res.data);
          }
          if (iscode(result, true)) {
            router.go(-1);
           setTimeout(() => {
              ruleForm.value.resetFields();
            form.value = {};
           },500);
          }
        })
        .catch((error) => {
              message.error('请完善表单');

        });
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      confirmSetPrice,
      confirmSetStock,
      onSubmit,
      addParameter,
      removesku,
      skus,
      addSku,
      allset,
      spec_many,
      cretateSpace,
      removeskuvalue,
      specGridCell,
    };
  },
};
</script>
<style lang="less">
@import url("@/style/app-warp/app-warp.less");
</style>
<style lang="less" scoped>
.content {
  overflow: hidden;
}
.ant-row {
  margin-bottom: 40px;
}

.editorContent {
  display: flex;

  .detailContent {
    background-image: url("../../../../assets/images/iphone.png");
    width: 327px;
    height: 727px;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 50px;
    word-break: break-all;
    padding: 50px 23px 10px;
  }
}

.cateItem {
  width: 195px;
  height: 73px;
  text-align: center;
  line-height: 73px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  margin-right: 26px;

  > label {
    width: 195px;
    height: 73px;
    display: block;
    position: relative;
    border: 2px solid #83c8dd;
  }

  .current {
    display: none;
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    line-height: 0;
    font-size: 0;
    pointer-events: none;
    border: 20px solid #4499ff;
    border-left-color: transparent;
    border-top-color: transparent;
    right: -1px;
    bottom: -1px;

    span {
      position: absolute;
      font-size: 14px;
      color: #fff;
      margin-top: 8px;
      transform: rotate(10deg);
    }
  }

  input:checked ~ label {
    border: 2px solid #4499ff;

    .current {
      display: block;
    }
  }
}

.otherItem {
  position: relative;
  border: 2px solid #83c8dd;

  .otherList {
    display: none;
    border: 2px solid #83c8dd;
    position: absolute;
    border-top: none;
    width: 287px;
    right: -2px;
    height: 100px;
    top: 80px;
    padding-top: 20px;

    &::before {
      content: "";
      width: 92px;
      height: 2px;
      position: absolute;
      top: 0;
      background-color: #83c8dd;
      left: 0;
    }
  }

  .white-line {
    position: absolute;
    background-color: #fff;
    right: -2px;
    top: -10px;
    width: 195px;
    height: 10px;
    box-sizing: border-box;
    border-left: 2px solid #83c8dd;
    border-right: 2px solid #83c8dd;
  }
  &:hover {
    border-bottom: none;
    .otherList {
      display: block;
    }
  }
}
</style>